import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Stack,
    Typography
} from '@mui/material';

const CrossAreaParamsDialog = ({ open, onClose, onConfirm, initialValues, selectionSize }) => {
    const [cols, setCols] = useState(initialValues?.cols || 20);
    const [rows, setRows] = useState(initialValues?.rows || 20);
    const [crossSize, setCrossSize] = useState(initialValues?.crossSize || 10);
    const [manualOverride, setManualOverride] = useState(false);

    // Reset form when initialValues change
    useEffect(() => {
        if (initialValues) {
            setCols(initialValues.cols || 20);
            setRows(initialValues.rows || 20);
            setCrossSize(initialValues.crossSize || 10);
            setManualOverride(false);
        }
    }, [initialValues]);

    // Auto-calculate cols/rows when crossSize changes (if not manually overridden)
    useEffect(() => {
        if (!manualOverride && selectionSize && crossSize > 0) {
            const newCols = Math.max(1, Math.round(selectionSize.width / crossSize));
            const newRows = Math.max(1, Math.round(selectionSize.height / crossSize));
            setCols(newCols);
            setRows(newRows);
        }
    }, [crossSize, selectionSize, manualOverride]);

    const handleColsChange = (e) => {
        setCols(parseInt(e.target.value) || 1);
        setManualOverride(true);
    };

    const handleRowsChange = (e) => {
        setRows(parseInt(e.target.value) || 1);
        setManualOverride(true);
    };

    const handleConfirm = () => {
        onConfirm({ cols: parseInt(cols), rows: parseInt(rows), crossSize: parseFloat(crossSize) });
        onClose();
    };

    // Calculate actual area size based on current cols/rows and crossSize
    const actualWidth = cols * crossSize;
    const actualHeight = rows * crossSize;

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>New Cross Area</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    {selectionSize && (
                        <Typography variant="body2" color="text.secondary">
                            Selected area: {selectionSize.width.toFixed(1)} × {selectionSize.height.toFixed(1)} units
                        </Typography>
                    )}
                    <TextField
                        label="Width (crosses)"
                        type="number"
                        value={cols}
                        onChange={handleColsChange}
                        fullWidth
                    />
                    <TextField
                        label="Height (crosses)"
                        type="number"
                        value={rows}
                        onChange={handleRowsChange}
                        fullWidth
                    />
                    <TextField
                        label="Cross size"
                        type="number"
                        value={crossSize}
                        onChange={(e) => setCrossSize(parseFloat(e.target.value) || 1)}
                        fullWidth
                    />
                    <Typography variant="body2" color="text.secondary">
                        Actual size: {actualWidth.toFixed(1)} × {actualHeight.toFixed(1)} units
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleConfirm} variant="contained">Confirm</Button>
            </DialogActions>
        </Dialog>
    );
};

export default CrossAreaParamsDialog;
